import workspaceQuery from 'graphql/queries/salesLedger/SalesAllocationWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/salesLedger/SalesAllocationListQuery.graphql';
import instanceQuery from 'graphql/queries/salesLedger/SalesAllocationQuery.graphql';
import defaultQuery from 'graphql/queries/salesLedger/SalesAllocationDefault.graphql';
import mutationQuery from 'graphql/mutations/salesLedger/SalesAllocationMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/salesLedger/SaveSalesAllocationTempMutation.graphql';
import fragment from 'graphql/fragments/salesLedger/SalesAllocationFragment.graphql';

import { formActionsForPermissions } from 'actions/salesLedger/SalesAllocationAction';

const SalesAllocation = {
  type: 'SalesAllocation',
  title: 'Customer Allocations',
  formUrl: '/Customers/Allocation/Details/',
  formTitle: 'Customer Allocations',
  workspaceUrl: '/Customers/Allocation/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  fragment,
  screenReference: 'SALES_LEDGER_ALLOCATIONS',
  actions: formActionsForPermissions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'REVERSED'],
    },
  ],
};

export default SalesAllocation;
